import { render, staticRenderFns } from "./UserKartei.vue?vue&type=template&id=e0b0f5c8&scoped=true"
import script from "./UserKartei.vue?vue&type=script&lang=js"
export * from "./UserKartei.vue?vue&type=script&lang=js"
import style0 from "./UserKartei.vue?vue&type=style&index=0&id=e0b0f5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b0f5c8",
  null
  
)

export default component.exports